module.exports = __webpack_public_path__ + "static/media/pencil.bold.5f627679.svg";